import { DashboardCustomerMembershipForm } from '#pages/DashboardCustomerMembership/components/Form';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import { useNavigate } from 'react-router';

import { SaveButton } from './components/SaveButton';
import { TotalPrice } from './components/TotalPrice';
import { useDashboardCustomerMembershipState } from './dahsboardCustomerMembershipState';

export const DashboardCustomerMembershipPage = () => {
  const navigate = useNavigate();

  const { setDashboardCustomerMembershipState } =
    useDashboardCustomerMembershipState();

  const onPrev = () => {
    setDashboardCustomerMembershipState({
      lectureId: '',
      sessionDuration: 0,
      round: 0,
      totalRound: 0,
      price: 0,
      isRequestPayment: false,
      startedDate: '',
      expiryPeriod: '',
      expiryDate: '',
      discount: null
    });

    navigate(-1);
  };

  return (
    <PrevHeaderBarWithTitleTemplate
      onPrev={onPrev}
      defaultBackground
      title={'수강권 추가'}
      rightContents={<SaveButton />}
    >
      <div className="px-20">
        <div className="w-full h-28"></div>
        <DashboardCustomerMembershipForm />
        <div className="w-full h-28"></div>
        <TotalPrice />
      </div>
    </PrevHeaderBarWithTitleTemplate>
  );
};
